<div class="searchbar__container">

  <span class="material-symbols-outlined searchbar__icon">
    search
  </span>
  <input #inputElement [(ngModel)]="searchKeyword" [placeholder]="placeholder" class="searchbar" type="search">
</div>
